import { BrokerType, brokerTypesData } from 'enums/shared/brokerType';

const mapBrokerTypeFromApi = (id: number): BrokerType => {
  switch (id) {
    case brokerTypesData[BrokerType.Tinkoff].id:
      return BrokerType.Tinkoff;
    case brokerTypesData[BrokerType.PE].id:
      return BrokerType.PE;
    case brokerTypesData[BrokerType.Crypto].id:
      return BrokerType.Crypto;
    case brokerTypesData[BrokerType.Arbitr].id:
      return BrokerType.Arbitr;
    case brokerTypesData[BrokerType.Finam].id:
      return BrokerType.Finam;
    case brokerTypesData[BrokerType.Binance].id:
      return BrokerType.Binance;
    case brokerTypesData[BrokerType.IPO].id:
      return BrokerType.IPO;
    case brokerTypesData[BrokerType.CryptoDeposit].id:
      return BrokerType.CryptoDeposit;
    case brokerTypesData[BrokerType.PrimeIPO].id:
      return BrokerType.PrimeIPO;
    default:
      return BrokerType.Tradernet;
  }
};

export default mapBrokerTypeFromApi;
